import { numberWithCommas } from './numberWithCommas'

const SUFFIXES: { [key: number]: string } = {
    1_000_000: 'M',
    1_000: 'k',
}

export const shortenNumber = (
    value: number
): { value: string; sign: string } => {
    const absoluteValue = Math.abs(value)
    const sign = value < 0 ? '-' : ''
    const sortedThresholds = Object.keys(SUFFIXES)
        .map((key) => Number(key))
        .sort((a, b) => b - a) // Sort descending

    for (const threshold of sortedThresholds) {
        if (absoluteValue >= threshold) {
            const suffix = SUFFIXES[threshold] ?? ''
            const roundedValue = parseFloat(
                (absoluteValue / threshold).toFixed(2)
            )

            return { value: `${numberWithCommas(roundedValue)}${suffix}`, sign }
        }
    }

    return { value: absoluteValue.toString(), sign }
}
